import { render, staticRenderFns } from "./CrewDetailsList.vue?vue&type=template&id=e25047c6&scoped=true&"
import script from "./CrewDetailsList.vue?vue&type=script&lang=js&"
export * from "./CrewDetailsList.vue?vue&type=script&lang=js&"
import style0 from "./CrewDetailsList.vue?vue&type=style&index=0&id=e25047c6&scoped=true&lang=css&"
import style1 from "./CrewDetailsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25047c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VChip,VDataTable,VProgressLinear})
